<span class="deltaker-navn" data-testid="navn">{{ skjema().value.deltaker!.medlem.navn }}</span>
<span class="deltaker-rolle">{{ aktivRolle() }}</span>
@if (visRepresentererKolonne()) {
  @if (skjema().value.deltaker!.aksjeeierRepresentasjoner.length == 0) {
    <span class="deltaker-representerer-navn"></span>
    <span class="deltaker-representerer-andel"></span>
  } @else if (skjema().value.deltaker!.aksjeeierRepresentasjoner.length == 1) {
    @let aksjeeier = skjema().value.deltaker!.aksjeeierRepresentasjoner[0];
    <span class="deltaker-representerer-navn">{{ aksjeeier.navn }}</span>
    <span class="deltaker-representerer-andel">{{ aksjeeier.eierandel | prosent }}</span>
  } @else {
    <span class="deltaker-representerer-navn deltaker-representerer-multiple" (click)="toggleRepresentasjoner()" data-testid="vis-alle-representerer" matTooltip="{{'Deltakeren representerer {antall} aksjonærer'|translate: {antall: skjema().value.deltaker!.aksjeeierRepresentasjoner.length} }}">
      {{ 'Representerer {antall}'|translate: {antall: skjema().value.deltaker!.aksjeeierRepresentasjoner.length} }}
      @if (viserRepresentasjoner()) {
        <mat-icon>keyboard_arrow_up</mat-icon>
      } @else {
        <mat-icon>keyboard_arrow_down</mat-icon>
      }
      @if (viserRepresentasjoner()) {
        @for (aksjeeier of skjema().value.deltaker!.aksjeeierRepresentasjoner; track aksjeeier.aksjeeierId) {
          <div class="aksjeeier">{{ aksjeeier.navn }}</div>
        }
      }
    </span>
    <span class="deltaker-representerer-andel">
      {{ sumAndelIProsent() | prosent }}
      @if (viserRepresentasjoner()) {
        @for (aksjeeier of skjema().value.deltaker!.aksjeeierRepresentasjoner; track aksjeeier.aksjeeierId) {
          <div class="aksjeeier-andel">{{ aksjeeier.eierandel | prosent }}</div>
        }
      }
    </span>
  }
}

<mat-form-field class="deltaker-kommentar">
  <input matInput [formControl]="skjema().controls.kommentar" [placeholder]="'Kommentar'|translate" data-testid="kommentar-felt">
  @if (skjema().controls.kommentar.hasError('maxlength')) {
    <mat-error data-testid="maxlength">{{ skjema().controls.kommentar.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
  }
</mat-form-field>

<mat-form-field class="deltaker-status">
  <mat-select [formControl]="skjema().controls.status" data-testid="status-felt">
    <mat-option [value]="statuser.deltatt">
      {{ 'deltatt'|translate }}
    </mat-option>
    <mat-option [value]="statuser.forfall">
      {{ 'forfall'|translate }}
    </mat-option>
    <mat-option [value]="statuser.ikkeInnkalt">
      {{ 'ikke innkalt'|translate }}
    </mat-option>
  </mat-select>
</mat-form-field>

<div class="deltaker-skal-signere">
  <mat-slide-toggle [formControl]="skjema().controls.skalSignere" data-testid="skal-signere-felt">
    {{ 'Skal signere'|translate }}
  </mat-slide-toggle>
  @if (skjema().controls.skalSignere.hasError(valideringsfeil.skjermet_kan_ikke_signere)) {
    <mat-error data-testid="skjermet_kan_ikke_signere">{{ 'Bruker har ikke tilgang til møte eller sak og kan ikke signere protokollen.'|translate }}</mat-error>
  }
</div>
